var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotalStaff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.186,
    height: 20.028,
    viewBox: "0 0 33.186 20.028",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_845",
    "data-name": "Group 845",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M364.644,350.407a3.62,3.62,0,0,0,3.616-3.617h0a3.617,3.617,0,1,0-3.616,3.617Zm0-6.3a2.686,2.686,0,0,1,2.682,2.682h0a2.683,2.683,0,1,1-2.682-2.683Z",
    transform: "translate(-357.833 -343.173)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M384.5,355.5h-4.38a4.6,4.6,0,0,0-4.468,3.445c-.133-.01-.267-.017-.4-.017h-4.938c-.136,0-.269.007-.4.017a4.6,4.6,0,0,0-4.469-3.445h-4.38a4.628,4.628,0,0,0-4.623,4.623v2.1a.468.468,0,0,0,.467.467h8.446a5.126,5.126,0,0,0-.193,1.391v1.9a.466.466,0,0,0,.467.467h14.311a.467.467,0,0,0,.467-.467v-1.9a5.18,5.18,0,0,0-.193-1.391h8.446a.467.467,0,0,0,.467-.467v-2.1A4.628,4.628,0,0,0,384.5,355.5Zm-27.129,6.257v-1.634a3.693,3.693,0,0,1,3.689-3.689h4.38a3.669,3.669,0,0,1,3.543,2.669,5.169,5.169,0,0,0-3.27,2.655Zm22.1,3.759H366.089v-1.435a4.221,4.221,0,0,1,.34-1.658l.01-.022a4.231,4.231,0,0,1,3.167-2.479h0l.01,0a4.155,4.155,0,0,1,.688-.058h4.938a4.2,4.2,0,0,1,.659.052l.038.008.018,0a4.227,4.227,0,0,1,3.153,2.477l.01.022a4.21,4.21,0,0,1,.34,1.659Zm8.72-3.759h-8.342a5.169,5.169,0,0,0-3.27-2.655,3.669,3.669,0,0,1,3.543-2.669h4.38a3.693,3.693,0,0,1,3.688,3.689Z",
    transform: "translate(-356.435 -346.926)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M392.048,350.407a3.617,3.617,0,1,0-3.617-3.617A3.62,3.62,0,0,0,392.048,350.407Zm0-6.3a2.684,2.684,0,0,1,2.682,2.682h0a2.683,2.683,0,1,1-2.682-2.682Z",
    transform: "translate(-366.173 -343.173)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M378.17,354.565a4.023,4.023,0,0,0,4.019-4.019h0a4.02,4.02,0,1,0-4.019,4.02Zm0-7.107a3.089,3.089,0,0,1,3.085,3.086h0a3.086,3.086,0,1,1-3.085-3.087Z",
    transform: "translate(-361.826 -344.193)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalStaff);
export default __webpack_public_path__ + "static/media/total_staff.bc0cbffa8e881e3a1e1db6a5e63d0fff.svg";
export { ForwardRef as ReactComponent };